module.exports = __webpack_public_path__ + "img/Rotation3.0a7f6abd.jpg";